import { useShallowEqualSelector } from '../useShallowEqualSelector'

export const useFlags = () => useShallowEqualSelector((state) => (
  state.moduleConfigReducer.associationConfig.extraFunctionalityFlags
))
